import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { ComingSoon, UsersList } from '@config/components';
import { useConfigContext } from '@config/context';

export const UsersPage = (): ReactElement => {
  const { t } = useTranslation();
  const { getUsers } = useConfigContext();

  if (!getUsers) return <ComingSoon sectionKey="users" />;

  return (
    <Page>
      <Page.Title>{t('config.sections.users')}</Page.Title>
      <Page.Content fill>
        <UsersList />
      </Page.Content>
    </Page>
  );
};
